// External libraries
import { action } from 'easy-peasy';

import type { UserActions, UserModel, UserState } from './types';

export const getUserState = (
  overrides: Partial<UserState> = {},
): UserState => ({
  isUserLoggedIn: false,
  // Passkey context will be updated only after a successful
  // planning call. The context creation is in parallel to
  // approvePayment call
  passkey: {
    context: '',
    isAvailable: false,
    isPasswordlessFlow: false,
    returnToMerchantUrl: '',
  },
  ...overrides,
});

const createUserActions = (): UserActions => ({
  setIsPasskeyAvailable: action((state, payload) => {
    state.passkey.isAvailable = Boolean(payload);
  }),
  setIsPasskeyPasswordlessFlow: action((state, payload) => {
    state.passkey.isPasswordlessFlow = Boolean(payload);
  }),
  setPasskeyIWCContext: action((state, payload) => {
    state.passkey.context = payload ?? '';
  }),
  setPasskeyReturnToMerchantUrl: action((state, payload) => {
    state.passkey.returnToMerchantUrl = payload ?? '';
  }),

  setUserLoggedIn: action(state => {
    state.isUserLoggedIn = true;
  }),
  setUserLoggedOut: action(state => {
    state.isUserLoggedIn = false;
  }),
});

export const userModelFactory = (): UserModel => ({
  ...getUserState(),
  ...createUserActions(),
});
